import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React from 'react';
import { useContext } from 'react';
import { t } from '../../../../../types/translation/Translator';
import InnerFilterContent, { FilterInnerContentProps } from '../../common/DropdownContent/DynamicFilterInnerContent';
import { BinStatus } from '../../../../../types/bin/binStatus';
import { BinStatusContext } from '../../../../../context/BinStatusContext';

export default function BinStatusFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<BinStatus>) {
  const { binStatuses } = useContext(BinStatusContext);

  return (
    <InnerFilterContent
      filter={filter}
      filterProps={{ filterProps, setFilterProps }}
      items={[...(filterProps.binStatus?.values() || [])]}
      text={item => binStatuses.get(item)?.status || t(TranslationKey.unknownBinStatus).singular.label}
      onRemove={i => {
        filterProps.binStatus?.delete(i);
        if (!filterProps.binStatus?.size) filterProps.binStatus = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
